import React from "react";
import {
  AnnouncementBannerBackground,
  AnnouncementBannerTitles,
  AnnouncementBannerContent,
  AnnouncementBannerTitle,
  AnnouncementBannerSubtitle,
  AnnouncementBannerCTAContainer,
  AnnouncementBannerCTA,
} from "./announcement-banner.styled";
import { AnnouncementBannerQuery } from "../../types/graphql";

interface IAnnouncmentBannerProps {
  data?: AnnouncementBannerQuery;
}

export const PureAnnouncementBanner = (props: IAnnouncmentBannerProps) => {
  const banner = props.data?.prismicAnnouncementBanner?.data;

  return (
    (banner && (
      <AnnouncementBannerBackground>
        <AnnouncementBannerContent>
          <AnnouncementBannerTitles>
            <AnnouncementBannerTitle>{banner.title}</AnnouncementBannerTitle>
            {banner.subtitle && (
              <AnnouncementBannerSubtitle>
                {banner.subtitle}
              </AnnouncementBannerSubtitle>
            )}
          </AnnouncementBannerTitles>
          {banner.cta_text && banner.cta_url && (
            <AnnouncementBannerCTAContainer>
              <AnnouncementBannerCTA
                kind="primary"
                className="md:!text-sm"
                scale="xsmall"
                pageSection="announcement-banner"
                ctaText={banner.cta_text}
                linkURL={banner.cta_url.url}
                target={banner.cta_url.target}
              />
            </AnnouncementBannerCTAContainer>
          )}
        </AnnouncementBannerContent>
      </AnnouncementBannerBackground>
    )) || <></>
  );
};
